module.exports = __webpack_public_path__ + "img/Weapon_15.4e72f6ca.png";